const list=[
    {value: '01', label: '学习'},
    {value: '02', label: '就业'},
    {value: '03', label: '商务'},
    {value: '04', label: '访问'},
    {value: '05', label: '旅游'},
    {value: '06', label: '探亲访友'},
    {value: '07', label: '寄养'},
    {value: '08', label: '难民'},
    {value: '09', label: '合作交流'},
    {value: '10', label: '定居'},
    {value: '11', label: '乘务'},
    {value: '12', label: '结婚'},
    {value: '13', label: '购房'},
    {value: '14', label: '就医'},
    {value: '15', label: '采访'},
    {value: '99', label: '其他'},
]
export default list